import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.07501 8.57422H8.57501M8.57501 8.57422H12.075M8.57501 8.57422V12.0742M8.57501 8.57422V5.07422M8.57501 16.4492C4.22577 16.4492 0.700012 12.9235 0.700012 8.57422C0.700012 4.22498 4.22577 0.699219 8.57501 0.699219C12.9243 0.699219 16.45 4.22498 16.45 8.57422C16.45 12.9235 12.9243 16.4492 8.57501 16.4492Z",
      stroke: "currentColor",
      "stroke-width": "1.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }